import React from 'react'

/** @deprecated Use icons from icons-v2-generated instead. */
export interface NushellIconProps {
  size?: number
  className?: string
  color?: string
}

/** @deprecated Use icons from icons-v2-generated instead. */
export const NushellIcon: React.FC<NushellIconProps> = ({ size = 16, className = '', color = 'white' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      className={className}
      viewBox="0 0 24 24">
      <path
        fill={color}
        d="M0 16.338h1.25v-5.7c.417-.624 1.205-1.309 2.127-1.309c1.176 0 1.34.64 1.34 2.247v4.762h1.25v-5.685c0-1.458-.67-2.32-2.202-2.32c-.923 0-1.964.46-2.59 1.264l-.103-1.1H0Zm10.177-7.842h-1.25v5.698c0 1.46.745 2.307 2.263 2.307c.921 0 1.889-.431 2.514-1.22l.104 1.057h1.072V8.496h-1.25v5.773c-.432.67-1.265 1.25-2.129 1.25c-.907 0-1.324-.446-1.324-1.458zm8.11-.997l-.61.952l5.251 3.229l-5.251 3.244l.669.922L24 12.32v-1.28z" />
    </svg>
  )
}

NushellIcon.displayName = 'NushellIcon'
